import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ModalWrapper, Content, ContentTheme } from './styled';

export const contextModalWidth = 213;
export const contextModalHeight = '100%';
export const arrowHeight = 15;

const findPositionArrowY = ({ isOutOfWindowX, positionY, positionArrowY, targetHeight, leftAlign }) => {
  if (!isOutOfWindowX || leftAlign) return positionArrowY || positionY - 10;

  // Adjust arrow position to top
  return positionY - targetHeight - arrowHeight;
};

const ContextModal = props => {
  const {
    color,
    overflow,
    contextTheme,
    show,
    borderRadius,
    leftAlign,
    positionArrow,
    positionX,
    positionY,
    positionArrowY,
    modalHeight,
    targetHeight,
    name,
    overflowWrap,
    children
  } = props;
  const bgColor = contextTheme ? '#3B4E5E' : color;
  const [modalBottom, setModalBottom] = useState(0);
  const [isOutOfWindowX, setIsOutOfWindowX] = useState(false);
  const adjustedPositionArrowY = findPositionArrowY({ isOutOfWindowX, positionY, positionArrowY, targetHeight });

  useEffect(() => {
    const isDefaultModalHeight = modalHeight === contextModalHeight;
    const targetToBottomHeight = innerHeight - positionY;

    if (show && !isDefaultModalHeight && targetToBottomHeight < modalHeight) {
      setModalBottom(targetToBottomHeight + targetHeight + 10);
      setIsOutOfWindowX(true);
    }
  }, [show]);

  return (
    show && (
      <ModalWrapper
        overflow={overflow}
        overflowWrap={overflowWrap}
        borderRadius={borderRadius}
        positionArrow={positionArrow - 8}
        positionX={positionX}
        positionY={positionY}
        positionArrowY={adjustedPositionArrowY}
        modalWidth={contextModalWidth}
        bgColor={bgColor}
        leftAlign={leftAlign}
        modalBottom={modalBottom}
        isOutOfWindowX={isOutOfWindowX}
      >
        {contextTheme ? <ContentTheme>{name}</ContentTheme> : <Content>{children}</Content>}
      </ModalWrapper>
    )
  );
};

ContextModal.defaultProps = {
  color: 'white',
  overflow: 'hidden',
  overflowWrap: 'normal',
  modalHeight: contextModalHeight,
  leftAlign: false
};

ContextModal.propTypes = {
  children: PropTypes.any,
  show: PropTypes.bool,
  positionX: PropTypes.number,
  positionY: PropTypes.number,
  positionArrow: PropTypes.number,
  positionArrowY: PropTypes.number,
  contextTheme: PropTypes.string,
  name: PropTypes.string,
  color: PropTypes.string,
  borderRadius: PropTypes.number,
  overflow: PropTypes.string,
  overflowWrap: PropTypes.string,
  leftAlign: PropTypes.bool,
  modalHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  targetHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ContextModal;
